<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<div class="shaibox">
					<el-input style="width: 200px;margin-right: 15px;" v-model="input" placeholder="项目名称"></el-input>
					<el-select v-model="value" placeholder="请选择" @change="qieChange">
						<el-option v-for="item in options" :key="item" :label="item" :value="item">
						</el-option>
					</el-select>
					<el-button type="primary" style="margin-left: 15px;" @click="getLists">搜索</el-button>
				</div>

				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="title" label="项目名称" width="180">
					</el-table-column>
					<el-table-column prop="type" label="项目类型">
					</el-table-column>
					<el-table-column prop="admin.real_name" label="所属客服">
					</el-table-column>
					<el-table-column prop="create_time" label="开通日期">
					</el-table-column>
					<el-table-column prop="end_time" label="到期日期">
					</el-table-column>
					<el-table-column prop="shou_money" label="产品价格">
					</el-table-column>
					<el-table-column label="项目状态">
						<template slot-scope="scope">
							<div class="taibox" v-if="scope.row.status == 0">未完成</div>
							<div class="taibox" v-if="scope.row.status == 1">已完成</div>
							<div class="taibox" v-if="scope.row.status == 2">已结清</div>
							<div class="taibox" v-if="scope.row.status == 3">已交付</div>
							<div class="taibox" v-if="scope.row.status == 4">转维护</div>
							<div class="taibox" v-if="scope.row.status == 5">维护中</div>
							<div class="taibox" v-if="scope.row.status == 200">不续费</div>
						</template>
					</el-table-column>
					<el-table-column prop="money" label="项目金额/欠额">
						<template slot-scope="scope">
							<div >{{scope.row.money}}/{{scope.row.qian_money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="repay_money" label="续费价格">
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button size="mini" type="primary"
								@click="handleDelete(scope.$index, scope.row.id)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="fenye">
					<FenPage :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getLists" />
				</div>

			</div>

			<el-dialog title="详情" top="7vh" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
				<div class="xubox">
					<div class="kebox">
						<div class="ketxt">
							项目名称
							<span>{{info.title}}</span>
						</div>
					</div>

					<div class="kebox">
						<div class="ketxt">
							项目金额
							<span>{{info.money}}</span>
						</div>
					</div>

					<div class="kebox">
						<div class="ketxt">
							项目备注
						</div>
						<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="info.auth" disabled>
						</el-input>
					</div>

					<div class="kebox">
						<div class="timetxt">
							开通日期
							<span>{{info.create_time}}</span>
						</div>
						<div class="timetxt" v-if="info.end_time">
							结束日期
							<span>{{info.end_time}}</span>
						</div>
					</div>

					<div class="kebox">
						<div class="timetxt">
							已收金额
							<span>{{info.shou_money}}</span>
						</div>
						<div class="timetxt">
							欠款金额
							<span>{{info.qian_money}}</span>
						</div>
					</div>
				</div>

				<div class="xubox">
					<div class="xqtitle">
						收款信息
					</div>

					<el-table :data="info.item" border style="width: 100%">
						<el-table-column prop="money" label="收款金额" >
						</el-table-column>
						<el-table-column prop="create_time" label="收款日期" >
						</el-table-column>
						
						<el-table-column prop="body" label="收款备注">
						</el-table-column>
					</el-table>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import FenPage from '../../components/FenPage.vue'
	export default {
		components:{
			FenPage
		},
		data() {
			return {
				// 搜索
				input: '',
				options: [],
				value: '',

				// 表格
				tableData: [],

				category:'',
				// 分页
				page_data: {
					limit: 20,
					page: 1,
					total:20,
				},

				// 弹框
				dialogVisible: false,
				// 弹框文本域
				textarea: '',
				showData: [{
					jine: '19000',
					date: '2016-05-02',
					beizhu: '首付款50%'
				},{
					jine: '9000',
					date: '2016-05-02',
					beizhu: '首付款50%'
				},{
					jine: '9000',
					date: '2016-05-02',
					beizhu: '首付款50%'
				},{
					jine: '9000',
					date: '2016-05-02',
					beizhu: '首付款50%'
				}],
				info:{},//弹框数据
			}
		},
		created() {
			this.getkaiCategory()
			this.getLists()
		},
		methods: {
			// 请求分类
			async getkaiCategory() {
				const res = await this.$api.getkaiCategory();
				this.options = res.data
			},
			// 选择分类
			qieChange(e) {
				this.category = e
				console.log(this.category)
			},
			// 请求列表
			async getLists() {
				this.tableData = []
				let param = {limit:this.page_data.limit,page:this.page_data.page}
				Object.assign(param, {
					title: this.input,
					category: this.category
				})
				console.log(param,'222')
				const res = await this.$api.getLists(param);
				this.tableData = res.data.data
				this.page_data.total = res.data.total
			},
			
			handleEdit(index, row) {
				console.log(index, row);
			},
			// 获取详情
			handleDelete(index, row) {
				console.log(index, row);
				this.dialogVisible = true
				this.getListDetail(row)
			},
			async getListDetail(id) {
				const res = await this.$api.getListDetail({
					id:id
				});
				this.info = res.data
			},
			

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			// 弹框
			handleClose(done) {
				this.dialogVisible = false
			},

		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}

	.shaibox {
		display: flex;
		align-items: center;
		padding-bottom: 25px;
	}

	.taibox {
		width: 60px;
		height: 20px;
		background-color: #E6A23C;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #ffffff;
	}

	.fenye {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
	}

	.el-dialog__header {
		background-color: #f8f8f8 !important;
	}

	.el-dialog__body {
		background-color: #f2f2f2 !important;
	}

	.el-dialog__footer {
		background-color: #f2f2f2 !important;
	}

	.xubox {
		background-color: #ffffff;
		padding: 15px;
		margin-bottom: 15px;
	}

	.kebox {
		display: flex;
		align-items: flex-start;
		padding-bottom: 30px;
	}

	.ketxt {
		font-size: 14px;
		color: #333333;
		flex-shrink: 0;
		padding-right: 15px;
	}

	.ketxt span {
		color: #999999;
		padding-left: 10px;
		font-size: 14px;
	}

	.el-dialog__footer {
		text-align: left;
	}

	.timetxt {
		font-size: 14px;
		color: #333333;
		flex-shrink: 0;
		width: 35%;
	}

	.timetxt span {
		color: #999999;
		padding-left: 10px;
		font-size: 14px;
	}

	.xqtitle {
		font-size: 14px;
		color: #333333;
		border-bottom: 1px solid #ddd;
		padding: 0 0 20px;
		margin-bottom: 15px;
	}
</style>